import { jsx, Fragment } from "react/jsx-runtime";
import { forwardRef, Children, cloneElement } from "react";
import stitches from "../theme.config.es.js";
import { domProps } from "../../utils/domProps.es.js";
const textInput = stitches.css({
  fontFamily: "$defaultFont",
  fontSize: "$text",
  display: "block",
  color: "$textAlt",
  width: "$full",
  backgroundColor: "white",
  border: "1px solid $borderAlt",
  borderRadius: "$regular",
  margin: 0,
  // inputs and buttons should be equivalent in size, but since inputs can't be a line-height lower than 1.25em
  // we have to use a line-height of 1.25rem and deduct the additional 0.25rem from the vertical padding
  lineHeight: "1.25rem",
  padding: "calc($100 - 0.125rem) $150",
  "&::placeholder": { color: "$gray650" },
  "&:focus": { outlineColor: "$colors$focusRing" },
  variants: {
    error: {
      true: {},
      false: {
        "&:enabled": { ":hover": { borderColor: "$gray500" } }
      }
    },
    touched: { true: {} },
    disabled: {
      true: {
        backgroundColor: "$gray250",
        borderColor: "$gray350",
        color: "$textDisabled"
      }
    },
    showInlineError: {
      true: {
        borderBottomRightRadius: "0",
        borderBottomLeftRadius: "0",
        "@medium": {
          borderBottomRightRadius: "$regular",
          borderBottomLeftRadius: "$regular"
        }
      }
    }
  },
  compoundVariants: [
    {
      error: "true",
      touched: "true",
      css: {
        borderColor: "$negative",
        // iconOffset
        paddingRight: "24px"
      }
    }
  ]
});
const CustomInput = ({ children, ...props }) => {
  const el = Children.only(children);
  const options = { ...props, error: Boolean(props.error) };
  return /* @__PURE__ */ jsx(Fragment, { children: cloneElement(el, domProps(el.props, textInput(options))) });
};
const EzTextInput = forwardRef(function EzTextInput2({ error, ...props }, ref) {
  const ElementType = props.multiLine ? "textarea" : "input";
  const options = { ...props, error: Boolean(error) };
  return /* @__PURE__ */ jsx(ElementType, { ref, ...domProps(props, textInput(options)) });
});
export {
  CustomInput,
  EzTextInput as default
};
//# sourceMappingURL=EzTextInput.es.js.map
